<template>
	<div class="service2">
		<div class="service2-c">
			 <img  class="service2-c-bg" src="../../../assets/ys/service/66.png" alt="">
			<div class="service2-info1" style="position: absolute;">
				Business Area
			</div>
		</div>
		
		<div class="service2-c1">
			<div class="service2-c1-c">
				<div class="service2-c-c-h">
					Planning and Design
				</div>
				<div class="service2-c-c-b">
					<div class="item">
						<img class="item-img" src="../../../assets/ys/service/11.png" alt="">
						<div class="item-div">Planning/Feasibility Study</div>
					</div>
					<div class="item item1">
						<img class="item-img" src="../../../assets/ys/service/22.png" alt="">
						<div class="item-div">Integrated energy scheme design</div>
					</div>
					<div class="item">
						<img class="item-img" src="../../../assets/ys/service/33.png" alt="">
						<div class="item-div">Engineering Integrated Design</div>
					</div>
				</div>
			</div>
		</div>
		
		
		
		<!-- <div class="service2-c3">
			<div class="service2-c3-c">
				<div class="l1">
					<div class="l1-h">
						works category
					</div>
					<div class="h1-f">
						<div class="t1">
							transformer substation
						</div>
						<div class="s1">
							Zhenzhong Transformer 110 Project
						</div>
						<img class="imgg" src="../../../assets/ys/service/55.png" alt="">
					</div>
				</div>
				<div class="r1">
					<div class="item" v-for="(item, index) in 8" :key="index">
						<div>Cement roof</div>
						<img src="../../../../public/imgs/service2/储能@2x.png" alt="">
					</div>
				</div>
			</div>
		</div> -->
		<div class="service2-c5">
			<div class="service2-c5-title">
				engineering construction
			</div>
			<div class="service2-c5-sec">
				<div class="imgs-item">
					<img class="imgs-item-bgimg" src="../../../assets/service/service2-111.png" alt="">
					<div class="imgs-item-box">
						<img class="imgs-item-logo" src="../../../assets/service/service21.png" alt="">
						<div class="t">Turnkey project</div>
					</div>
				</div>
				<div class="imgs-item">
					<img class="imgs-item-bgimg" src="../../../assets/service/service2-222.png" alt="">
					
					<div class="imgs-item-box">
						<img class="imgs-item-logo" src="../../../assets/service/service21.png" alt="">
						<div class="t">Engineering renovation and maintenance</div>
					</div>
				</div>
				<div class="imgs-item">
					<img class="imgs-item-bgimg" src="../../../assets/service/service2-333.png" alt="">
					
					<div class="imgs-item-box">
						<img class="imgs-item-logo" src="../../../assets/service/service222.png" alt="">
						<div class="t">Engineering construction agency</div>
					</div>
				</div>
				<div class="imgs-item">
					<img class="imgs-item-bgimg" src="../../../assets/service/service2-444.png" alt="">
					
					<div class="imgs-item-box">
						<img class="imgs-item-logo" src="../../../assets/service/service24.png" alt="">
						<div class="t">Commissioning tests</div>
					</div>
				</div>
			</div>
		</div>
	    
		
	</div>
</template>

<script>
	export default {
		props: {
			list: {
				type: Array,
				default: []
			}
		},
		data() {
			return {

			}
		},
		created() {

		},
		methods: {

		}
	}
</script>

<style lang="scss">
	div {
		box-sizing: border-box;
	}

	.service2 {



		.service2-c {

			background-color: white;

			position: relative;

			.service2-c-bg {
				width: 100%;
				height: auto;
				
			}

			.service2-info1 {
				left: 0;
				width: 100%;
                text-align: center;
				color: #332C2B;
				position: relative;
				z-index: 99;
			}
		}

		.service2-c1 {

			background-color: white;

			justify-content: center;
			position: relative;

			.service2-c1-c {

				.service2-c-c-h {
					text-align: center;

					color: #332C2B;
				}

				.service2-c-c-b {

					justify-content: space-between;

					.item {
						 transition: transform 0.3s;

						position: relative;

						// img {
						// 	position: absolute;

						// 	z-index: 1;
						// }

						div {
							position: relative;
							z-index: 3;

							color: #FFFFFF;
						}
					}
					.item:hover {
					       transition: width 0.3s, height 0.3s;
					       transform: scale(0.95);
					       
					      }
				}
			}
		}

		

		.service2-c3 {

			background-color: #F5F5F5;

			justify-content: center;
			position: relative;
			color: #fff;

			.service2-c3-c {

				flex-direction: row;
				justify-content: space-between;

				.l1 {

					flex-direction: column;
					justify-content: space-between;

					// background-color: #666666;
					.l1-h {
						font-weight: 500;

						color: #332C2B;
					}

					.l1-f {

						flex-direction: column;
						justify-content: flex-end;


					}

					.t1 {
						color: #332C2B;
					}

					.s1 {

						color: #666666;
					}

				}

				.r1 {

					flex-wrap: wrap;
					justify-content: space-between;
					align-items: center;

					.item {

						justify-content: space-between;
						align-items: center;
						background-color: white;

						div {
							color: #332C2B;
						}

					}
				}
			}
		}
        
		.service2-c5 {
			width: 100%;
			background-color: #F3F9F9;
		
			.service2-c5-title {
				width: 100%;
				color: #332C2B;
				text-align: center;
			}
		
			.service2-c5-sec {
				display: flex;
				justify-content: space-between;
				align-items: center;
				flex-wrap: wrap;
		
				.imgs-item:hover {
					transition: width 0.3s, height 0.3s;
					transform: scale(0.95);
				}
		
				.imgs-item {
					transition: transform 0.3s;
					position: relative;
					color: white;
					.imgs-item-bgimg {
						width: 100%;
						height: auto;
						min-height: 160px;
					}
					.imgs-item-box {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						display: flex;
						flex-direction: column;
						justify-content: center;
						align-items: center;
					}
		
					.imgs-item-logo {
					}
					.t {
						width: 100%;
						text-align: center;
						color: white;
					}
		
				}
			}
		}
	}

	@media screen and (min-width: 1200px) {
		.service2 {
			width: 100%;


			.service2-c {
				width: 100%;

				.service2-info1 {
					font-size: 28px;
					top: 30px;
				}
			}

			.service2-c1 {
				width: 100%;
				display: flex;
				padding: 50px 20px;

				.service2-c1-c {
					width: 100%;

					.service2-c-c-h {
						font-size: 28px;
					}

					.service2-c-c-b {
						width: 100%;
						margin-top: 40px;
						// padding: 0 20px;
						display: flex;

						.item1 {
							margin-top: 170px;
						}

						.item {
							width: calc(33.3% - 20px);
							.item-div {
								font-size: 28px;
								top: 50px;
								left: 40px;
							}
						}
					}
				}
			}

			

			.service2-c3 {
				width: 100%;
				display: flex;
				height: 690px;
				padding: 80px 0;

				.service2-c3-c {
					width: 1200px;
					display: flex;

					.l1 {
						width: 33.3%;
						height: 500px;
						display: flex;

						.l1-h {
							font-size: 56px;
						}

						.l1-f {
							width: 100%;
							display: flex;
						}

						.t1 {
							font-size: 24px;
						}

						.s1 {
							margin-top: 8px;
							font-size: 18px;
						}

						.imgg {
							margin-top: 20px;
							width: 100%;
							height: 269px;

						}
					}

					.r1 {
						width: calc(66.7% - 20px);
						display: flex;
						margin-bottom: 24px;

						.item {
							width: calc(50% - 12px);
							height: 110px;
							display: flex;
							padding-left: 24px;

							div {
								font-size: 22px;
							}

							img {
								width: 160px;
								height: 110px;
							}
						}
					}
				}
			}
            
			.service2-c5 {
				padding:60px 0 ;
			
				.service2-c5-title {
					font-size: 24px;
				}
			
				.service2-c5-sec {
					width: 1200px;
					margin-top: 40px;
					margin-left: calc(50% - 600px);
			
					
			
					.imgs-item {
						width: calc(50% - 10px);
						margin-bottom: 20px;
						.imgs-item-logo {
							width: 50px;
							height: 50px;
						}
						.t {
							margin-top: 10px;
							font-size: 20px;
						}
			
					}
				}
			}
		}

	}

	@media screen and (max-width: 1200px) {
		.service2 {
			width: 100%;


			.service2-c {
				width: 100%;
				.service2-info1 {
					font-size: 28px;
					top: 24px;
				}
			}

			.service2-c1 {
				width: 100%;
				display: flex;
				padding: 60px 0;

				.service2-c1-c {
					width: 1200px;

					.service2-c-c-h {
						font-size: 32px;
					}

					.service2-c-c-b {
						width: 100%;
						margin-top: 50px;
						// padding: 0 20px;
						display: flex;

						.item1 {
							margin-top: 120px;
						}

						.item {
							width: calc(33.3% - 12px);
							.item-div {
								font-size: 24px;
								top: 40px;
								left: 30px;
							}
						}
					}
				}
			}

			

			.service2-c3 {
				width: 100%;
				display: flex;
				// height: 500px;
				padding: 50px 20px;

				.service2-c3-c {
					width: 100%;
					display: flex;

					.l1 {
						width: 33.3%;
						height: 350px;
						display: flex;

						.l1-h {
							font-size: 32px;
						}

						.l1-f {
							width: 100%;
							display: flex;
						}

						.t1 {
							font-size: 18;
						}

						.s1 {
							margin-top: 8px;
							font-size: 15px;
						}

						.imgg {
							margin-top: 12px;
							width: 100%;
							height: 120px;

						}
					}

					.r1 {
						width: calc(66.7% - 20px);
						display: flex;
						margin-bottom: 18px;

						.item {
							width: calc(50% - 12px);
							height: 80px;
							display: flex;
							padding-left: 12px;

							div {
								font-size: 15px;
							}

							img {
								width: 100px;
								height: 80px;
							}
						}
					}
				}
			}
            
			.service2-c5 {
				padding: 40px 0 ;
			
				.service2-c5-title {
					font-size: 20px;
				}
			
				.service2-c5-sec {
					width: 100%;
					margin-top: 30px;
			
					
			
					.imgs-item {
						width: calc(50% - 10px);
						margin-bottom: 20px;
						.imgs-item-logo {
							width: 36px;
							height: 36px;
						}
						.t {
							margin-top: 6px;
							font-size: 17px;
						}
			
					}
				}
			}
		}

	}

	@media screen and (max-width: 880px) {
		.service2 {
			width: 100%;

			.service2-c {
				width: 100%;
				.service2-info1 {
					font-size: 15px;
					top: 15px;
				}
			}

			.service2-c1 {
				width: 100%;
				display: flex;
				padding: 30px 0;

				.service2-c1-c {
					width: 100%;

					.service2-c-c-h {
						font-size: 18px;
					}

					.service2-c-c-b {
						width: 100%;
						margin-top: 24px;
						// padding: 0 12px;
						display: flex;

						.item1 {
							margin-top: 50px;
						}

						.item {
							width: calc(33.3% - 10px);
							.item-div {
								font-size: 14px;
								top: 30px;
								left: 20px;
							}
						}
					}
				}
			}

			

			.service2-c3 {
				width: 100%;
				display: flex;
				padding: 30px 12px;

				.service2-c3-c {
					width: 100%;
					display: flex;
					flex-direction: column;

					.l1 {
						width: 100%;
						height: 350px;
						display: flex;

						.l1-h {
							font-size: 20px;
						}

						.l1-f {
							width: 100%;
							display: flex;
						}

						.t1 {
							font-size: 16px;
						}

						.s1 {
							margin-top: 8px;
							font-size: 14px;
						}

						.imgg {
							margin-top: 12px;
							width: 100%;
							height: 120px;

						}
					}

					.r1 {
						margin-top: 20px;
						width: 100%;
						display: flex;
						margin-bottom: 18px;
						flex-wrap: wrap;

						.item {
							width: calc(50% - 12px);
							height: 80px;
							display: flex;
							margin-bottom: 12px;
							padding-left: 12px;

							div {
								font-size: 15px;
							}

							img {
								width: 100px;
								height: 80px;
							}
						}
					}
				}
			}
            
			
			.service2-c5 {
				padding: 20px  0 ;
			
				.service2-c5-title {
					font-size: 16px;
				}
			
				.service2-c5-sec {
					width: 100%;
					margin-top: 16px;
			
					
			
					.imgs-item {
						width: calc(50% - 6px);
						margin-bottom: 12px;
						.imgs-item-logo {
							width: 24px;
							height: 24px;
						}
						.t {
							margin-top: 6px;
							font-size: 14px;
						}
			
					}
				}
			}
		}

	}
</style>